const phoneRegex = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
const passwordRegex = /^[A-Za-z0-9@_*$!()-+=]{6,32}$/
const projectIdRegex = /^metaAnalysis\d{20}$/


export function downloadBlob(data) {
  let blob = new Blob([data.file], {type: 'application/zip'})
  let url = window.URL.createObjectURL(blob)
  const link = document.createElement('a') // 创建a标签
  link.href = url
  link.download = data.fileName // 重命名文件
  link.click()
  URL.revokeObjectURL(url) // 释放内存
}

export function simulationCompareRegex(str1, str2) {
  var newStr1 = str1.toLowerCase()
  var newStr2 = str2.toLowerCase()
  var len = Math.min(str1.length, str2.length);
  console.log(len)
  for(var i = 0; i < len; i++) {
    if(newStr1.charAt(i) != newStr2.charAt(i)) {
      return newStr1.charCodeAt(i) - newStr2.charCodeAt(i);
    }
  }
  if(str1.length != str2.length) return str1.length - str2.length
  for(var i = 0; i < len; i++) {
    if(str1.charAt(i) != str2.charAt(i)) {
      return -(str1.charCodeAt(i) - str2.charCodeAt(i))
    }
  }
  return 0
}

export function checkPhone (phone) {
  return phoneRegex.test(phone)
}
export function checkPassword (password) {
  return passwordRegex.test(password)
}
export function checkAccount (account) {
  return checkPhone(account) || checkProjectId(account)
}
export function checkProjectId (projectId) {
  return projectIdRegex.test(projectId)
}

export var checkNameRule = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('姓名不能为空'))
  }
  if (value.length < 2 || value.length > 20) {
    return callback(new Error('姓名长度为2-20'))
  }
  callback()
}
export var checkNameOrEmptyRule = (rule, value, callback) => {
  if (value && (value.length < 2 || value.length > 20)) {
    return callback(new Error('姓名长度为2-20'))
  }
  callback()
}
export var checkPhoneRule = (rule, value, callback) => {
  if (value) {
    if (!checkPhone(value)) {
      return callback(new Error('电话号码格式错误'))
    }else {
      return callback()
    }
  }else {
    return callback(new Error('手机号不为空'))
  }

}
export var checkPhoneOrEmptyRule = (rule, value, callback) => {
  if (value && !checkPhone(value)) {
    return callback(new Error('电话号码格式错误'))
  }
  callback()
}
// 目前账号支持手机号码和项目号
export var checkAccountRule = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('账号不能为空'))
  }
  // if (!checkPhone(value) && !checkProjectId(value)) {
  //   return callback(new Error('账号格式错误'))
  // }
  callback()
}
export var checkPasswordRule = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('密码不能为空'))
  }
  callback()
}
// 邮箱校验
export var checkMail=(rule, email, callback)=>{
  if(email){
    var emailRegExp=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    if(emailRegExp.test(email))	{
      callback()
    }else{
    return callback(  new Error('邮箱格式不对'))
    }
  }else {
    return callback( new Error('邮箱不能为空！'))
  }
}
// 邮箱校验可为空
export var checkMailOrEmpty=(rule, email, callback)=>{
  if(email){
    var emailRegExp=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    if(emailRegExp.test(email))	{
      callback()
    }else{
    return callback(  new Error('邮箱格式不对'))
    }
  }else {
    return callback()
  }
}
export var checkAuthorizationCode=(rule, authorizationCode, callback)=>{
  if(authorizationCode){
    callback()
  }else {
    return callback( new Error('邮箱授权码不能为空！'))
  }
}


 export function fileDownload(data,name) {
  const blob = new Blob([data], { type: 'text/xls/xlsx;charset=UTF-8' });
  const downloadElement = document.createElement('a');
  // 创建下载链接
  const href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  // 下载文件名
   if(name===undefined){
     name = data.fileName
   }
  downloadElement.download =decodeURI(name)
  document.body.appendChild(downloadElement);
  downloadElement.click();
  // 移除元素
  document.body.removeChild(downloadElement);
  // 释放blob对象
  window.URL.revokeObjectURL(href);
}
export function downPdf(data,name) {
  const blob = new Blob([data], {type:  "application/pdf;charset=utf-8"});
  const downloadElements = document.createElement('a');
  // 创建下载链接
  const href = window.URL.createObjectURL(blob);
  downloadElements.href = href;
  // 下载文件名
  if(name===undefined){
    name = data.fileName
  }
  downloadElements.download =decodeURI(name)
  document.body.appendChild(downloadElements);
  downloadElements.click();
  // 移除元素
  document.body.removeChild(downloadElements);
  // 释放blob对象
  window.URL.revokeObjectURL(href);
  return true
}
 export function checkIsColor(bgVal) {
  let type='';
  if(/^rgb\(/.test(bgVal)){
    //如果是rgb开头，200-249，250-255，0-199
    type = "^[rR][gG][Bb][\(]([\\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?)[\\s]*,){2}[\\s]*(2[0-4]\\d|25[0-5]|[01]?\\d\\d?)[\\s]*[\)]{1}$";
  }else if(/^rgba\(/.test(bgVal)){
    //如果是rgba开头，判断0-255:200-249，250-255，0-199 判断0-1：0 1 1.0 0.0-0.9
    type = "^[rR][gG][Bb][Aa][\(]([\\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?)[\\s]*,){3}[\\s]*(1|1.0|0|0.[0-9])[\\s]*[\)]{1}$";
  }else if(/^#/.test(bgVal)){
    //六位或者三位
    type = "^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$"
  }else if(/^hsl\(/.test(bgVal)){
    //判断0-360 判断0-100%(0可以没有百分号)
    type = "^[hH][Ss][Ll][\(]([\\s]*(2[0-9][0-9]|360｜3[0-5][0-9]|[01]?[0-9][0-9]?)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*)[\)]$";
  }else if(/^hsla\(/.test(bgVal)){
    type = "^[hH][Ss][Ll][Aa][\(]([\\s]*(2[0-9][0-9]|360｜3[0-5][0-9]|[01]?[0-9][0-9]?)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*,){2}([\\s]*(1|1.0|0|0.[0-9])[\\s]*)[\)]$";
  }else {
    return true;
  }
  let re = new RegExp(type);
  return !re.test(bgVal)
}
export function checkIsNumber(value){
  let re=/^\d+(?=.{0,1}\d+$|$)/ //包括小数
  if(re.test(value)){
    return true
  }
  return false
}
export function checkIsNumber1(value){
  let re=/^-?\d+$/ //整数
  if(re.test(value)){
    return true
  }
  return false
}
export function checkIsIntNumber(value){
  let reg = /^[1-9]\d*$/;
  if(reg.test(value)){
    return true
  }
  return false
}

export function addZero(index){
  if(index>=10){
    return ""
  }
  return "0"
}
 export function DataConvert(d) {
  d = new Date(d)
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate();
  var hours = d.getHours();
  var min = d.getMinutes();
  var seconds = d.getSeconds();

  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;
  if (hours < 0) hours = '0' + hours;
  if (min < 10) min = '0' + min;
  if (seconds < 10) seconds = '0' + seconds;

  var res=year+'-'+month+'-'+day+'\t'+hours+':'+min+':'+seconds
  return res;
}
export function addT(d){
  let index=d.indexOf('\t')
  let d1=d.substring(0,index)
  console.log(d)
  let d2=(d.substring(index+1))
  return d1+'T'+d2
}
export function antdSort(info,colum){

  var rankArr = []
  // 数字0开头
  var zeroArr = info .filter((ele, index) => {
    if (Number(ele.name.substr(0, 1)) === 0) {
      return !isNaN(Number(ele.name.substr(0, 1)))
    }
  })
  // 数字0开头排序
  zeroArr = zeroArr.sort((a, b) => {
    // return parseInt(a.name) - parseInt(b.name)
    return a.name.replace(/[^0-9]/ig, '') - b.name.replace(/[^0-9]/ig, '')
  })
  rankArr = zeroArr
  // 数字非0开头
  var numArr = info .filter((ele, index) => {
    if (Number(ele.name.substr(0, 1)) !== 0) {
      return !isNaN(Number(ele.name.substr(0, 1)))
    }
  })
// 数字非0开头排序
  numArr = numArr.sort((a, b) => {
    return a.name.replace(/[^0-9]/ig, '') - b.name.replace(/[^0-9]/ig, '')
  })
  // 汉字开头
  var reg = new RegExp('^[\u4e00-\u9fa5]')
  var wordArr = info .filter((ele, index) => {
    return reg.test(ele.name.substr(0, 1))
  })
// 汉字开头排序
  wordArr = wordArr.sort((a, b) => {
    return a.name.localeCompare(b.name)
  })
// 大写字母开头
  var regUpper = /^[A-Z]+$/
  var upperArr = info .filter((ele, index) => {
    return regUpper.test(ele.name.substr(0, 1))
  })
// 大写字母开头排序
  upperArr = upperArr.sort((a, b) => {
    return a.name.localeCompare(b.name)
  })
// 剩余其他的开头
  var otherArr = info .filter((ele, index) => {
    return isNaN(Number(ele.name.substr(0, 1))) && !reg.test(ele.name.substr(0, 1)) && !regUpper.test(ele.name.substr(0, 1))
  })
// 剩余其他的开头排序
  otherArr = otherArr.sort((a, b) => {
    return a.name.localeCompare(b.name)
  })
  info  = rankArr
  info  = this.info.concat(numArr, wordArr, upperArr, otherArr)
}
export function normalizeShowFileName(first,sec,third,name) {//规范名字的展示，01-01-01.xxx
  return  first + '-' + sec + '-' + addZero(third) +third+ '.' + name
}

//判断两数组元素是否相同
export function isSameArr(arr1 ,arr2){
  if (arr1.length !== arr2.length) {
    return false;
  }
  // 使用 every 方法判断每个元素是否都包含在另一个数组中
  return arr1.every((item) => arr2.includes(item));
}



